export const KEY_CODE_ESCAPE = 27;
export const KEY_CODE_ENTER = 13;

export const KEY_CODE_UP = 38;
export const KEY_CODE_DOWN = 40;

export const KEY_CODE_PAGE_UP = 33;
export const KEY_CODE_PAGE_DOWN = 34;
